import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  entered_date: "",
  pallet_code: "",
  status: "",
};

const ColdStorageFilter = ({ onApplyFilter, onClose, filters = {} }) => {
  const [filtersData, setFiltersData] = useState({
    entered_date: filters.entered_date || "",
    pallet_code: filters.pallet_code || "",
    status: filters.status || "",
  });

  const { _t } = useTranslator();

  useEffect(() => {
    setFiltersData({
      entered_date: filters.entered_date || "",
      pallet_code: filters.pallet_code || "",
      status: filters.status || "",
    });
  }, [filters.entered_date, filters.pallet_code, filters.status]);

  // cold_stored', 'ripening', 'sorting', 'moved'
  const statuses = [
    {
      label: _t("Ready For Ripening", "Ready For Ripening"),
      value: "cold_stored",
    },
    {
      label: _t("ripening", "Ripening"),
      value: "ripening",
    },
    {
      label: _t("sorting", "sorting"),
      value: "sorting",
    },
    {
      label: _t("moved", "moved"),
      value: "moved",
    }
  ];

  const handleChange = (e) => {
    setFiltersData({ ...filtersData, [e.target.name]: e.target.value });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) onClose();
  };

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>

      <InputWithLabel
        label={_t("entered_date", "Entered Date")}
        type="date"
        name="entered_date"
        value={filtersData.entered_date}
        onChange={handleChange}
      />

      <InputWithLabel
        label={_t("pallet_code", "Pallet Code")}
        type="text"
        name="pallet_code"
        value={filtersData.pallet_code}
        onChange={handleChange}
      />
      <SelectBox
        label={_t("status", "Status")}
        name="status"
        value={filtersData.status}
        onChange={handleChange}
        options={statuses?.map((list) => ({
          value: list.value,
          label: _t(list.label, list.label),
        }))}
      />

      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default ColdStorageFilter;
